import { useContext, useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function VerifyEmail() {
  const { verifyLoginEmailToken } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setLoading(false);
        setError("Verification token is missing.");
        return;
      }

      const result = await verifyLoginEmailToken(token);
      setLoading(false);

      if (!result.ok) {
        setError(result.error);
        return;
      }

      if (result.email) {
        localStorage.setItem("login_verified_email_v1", result.email.toLowerCase());
      }
      setMessage(result.message);
    };

    verify();
  }, [token, verifyLoginEmailToken]);

  return (
    <div className="auth-box">
      <h2>Email Verification</h2>
      {loading && <p className="page-muted">Verifying your email...</p>}
      {!loading && error && <p className="submit-error">{error}</p>}
      {!loading && !error && <p className="submit-success">{message || "Your gmail is verified."}</p>}
      <Link to="/login" className="btn" style={{ textAlign: "center" }}>
        Go to Login
      </Link>
    </div>
  );
}
